import React, { useState } from 'react';
import { Table, Button, Input, Select, Popconfirm, Space, Card } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { getSearchApi } from '../../../network/itemList';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { getSearchPatients } from '../../../network/appointment';
const TaxesList = ({ setDataSourceTax, dataSourceTax, t, form }) => {
  const [count, setCount] = useState(0);
  const [searchTextItemTaxTemplate, setSearchTextItemTaxTemplate] =
    useState('');
  const { data: ItemTaxTemplate } = useQuery({
    queryKey: [queryKeys.getItemTaxTemplate],
    queryFn: () =>
      getSearchPatients('Item Tax Template', searchTextItemTaxTemplate),
    keepPreviousData: true,
    enabled:
      searchTextItemTaxTemplate?.length >= 3 ||
      searchTextItemTaxTemplate?.length === 0,
  });
  const columns = [
    {
      title: t.itemTaxTemplate,
      dataIndex: 'item_tax_template',
      render: (text, record, index) => (
        <Select
          placeholder={t.itemTaxTemplate}
          style={{ width: '100%' }}
          filterOption={false}
          popupMatchSelectWidth={false}
          onSearch={(value) => {
            setSearchTextItemTaxTemplate(value);
          }}
          options={ItemTaxTemplate?.message?.map((item) => ({
            label: item.description,
            value: item.value,
          }))}
          value={record.item_tax_template}
          onChange={(value) => {
            const newDataSource = [...dataSourceTax];
            newDataSource[index] = {
              ...newDataSource[index],
              item_tax_template: value,
            };
            setDataSourceTax(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.minimumNetRate,
      dataIndex: 'minimum_net_rate',
      render: (text, record, index) => (
        <Input
          placeholder={t.minimumNetRate}
          style={{ width: '300px' }}
          value={record.minimum_net_rate}
          type="number"
          min={0}
          onChange={(e) => {
            const newDataSource = [...dataSourceTax];
            newDataSource[index] = {
              ...newDataSource[index],
              minimum_net_rate: e.target.value,
            };
            setDataSourceTax(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.maximumNetRate,
      dataIndex: 'maximum_net_rate',
      render: (text, record, index) => (
        <Input
          placeholder={t.TaxRate}
          style={{ width: '300px' }}
          value={record.maximum_net_rate}
          type="number"
          min={0}
          onChange={(e) => {
            const newDataSource = [...dataSourceTax];
            newDataSource[index] = {
              ...newDataSource[index],
              maximum_net_rate: e.target.value,
            };
            setDataSourceTax(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.action,
      key: 'action',
      render: (text, record, index) => (
        <Space>
          <Popconfirm
            title={t.confirmDelete}
            onConfirm={() => handleDelete(record.key)}
          >
            <Button
              type="primary"
              danger
              icon={<DeleteOutlined />}
              size="small"
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const handleAdd = () => {
    const newData = {
      key: count,
      uom: '',
      conversion_factor: '',
    };
    setDataSourceTax((prevDataSource) => [...prevDataSource, newData]);
    setCount(count + 1);
  };

  const handleDelete = (key) => {
    const newDataSource = dataSourceTax.filter((item) => item.key !== key);
    setDataSourceTax(newDataSource);
  };

  return (
    <Card>
      <Table
        className="table_custom"
        dataSource={dataSourceTax}
        columns={columns}
        pagination={{
          hideOnSinglePage: true,
        }}
        scroll={{ x: 'max-content' }}
        // className="table"
        rowKey="key"
      />
      <Button
        onClick={handleAdd}
        type="primary"
        ghost
        style={{ marginTop: '20px', borderRadius: '6px' }}
        icon={<PlusOutlined />}
        size="small"
      >
        {t.addRow}
      </Button>
    </Card>
  );
};

export default TaxesList;
